module.exports = __webpack_public_path__ + "static/media/63-palm-springs.146fef2b.jpg";